import * as React from "react"
import step1 from "@/features/chat/sections/HowItWorks/assets/step1.webp"
import step2 from "@/features/chat/sections/HowItWorks/assets/step2.webp"
import step3 from "@/features/chat/sections/HowItWorks/assets/step3.webp"

export type StepData = {
  id: number
  label: string
  text: React.ReactNode
  image: string
}

export const steps: StepData[] = [
  {
    id: 0,
    label: "Поддержка",
    image: step1,
    text: (
      <>
        <h3>Что делает сервис</h3>
        <p>AI-бот отвечает на типовые вопросы 24/7 и мгновенно передает сложные кейсы оператору</p>
        <h3>
          Какую <span>пользу</span> получает бизнес
        </h3>
        <p>Снижение нагрузки на команду до 40% и рост удовлетворенности клиентов (CSAT) за счет мгновенных ответов</p>
      </>
    ),
  },
  {
    id: 1,
    label: "Продажи",
    image: step2,
    text: (
      <>
        <h3>Что делает сервис</h3>
        <p>Квалифицирует лидов прямо на сайте и передает в продажи только самых целевых вместе с историей их действий</p>
        <h3>
          Какую <span>пользу</span> получает бизнес
        </h3>
        <p>
          Благодаря автоматической квалификации и бесшовной передаче данных в вашу CRM-систему, менеджеры получают не просто контакт, а полную историю действий
          пользователя на сайте, что сокращает цикл сделки
        </p>
      </>
    ),
  },
  {
    id: 2,
    label: "Маркетинг",
    image: step3,
    text: (
      <>
        <h3>Что делает сервис</h3>
        <p>Отслеживает действия даже анонимных посетителей и вовлекает их в диалог через проактивные сообщения</p>
        <h3>
          Какую <span>пользу</span> получает бизнес
        </h3>
        <p>Больше качественных лидов за счет персонализированных сценариев коммуникации на основе поведения пользователя</p>
      </>
    ),
  },
]
